import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { FaGlobe, FaLock } from "react-icons/fa";
import { checkIp } from "../../../api/modules/b2droppie.class";

function IpRestrictionsCheck({ setLoading, ipCheckData, setIpCheckData }) {
  const location = useLocation();

  useEffect(() => {
    checkIpRestrictions();
  }, [location.pathname]);

  const checkIpRestrictions = async () => {
    setLoading(true);
    try {
      const response = await checkIp();
      const data = response?.data;
      setIpCheckData(data);
    } catch (err) {
      console.error("Failed to fetch IP restriction data:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (
      ipCheckData &&
      ipCheckData.status === 403 &&
      ipCheckData.success === false
    ) {
      document.body.style.overflow = "hidden";

      const blockKeys = (e) => e.preventDefault();
      window.addEventListener("keydown", blockKeys, true);
      window.addEventListener("contextmenu", blockKeys, true);

      return () => {
        document.body.style.pointerEvents = "auto";
        document.body.style.overflow = "auto";
        window.removeEventListener("keydown", blockKeys, true);
        window.removeEventListener("click", blockKeys, true);
        window.removeEventListener("contextmenu", blockKeys, true);
      };
    }
  }, [ipCheckData]);

  if (
    ipCheckData &&
    ipCheckData.status === 403 &&
    ipCheckData.success === false
  ) {
    return (
      <div
        className="ip-restriction-overlay"
        onClick={(e) => e.stopPropagation()}
      >
        <div
          className="ip-restriction-modal"
          onClick={(e) => e.stopPropagation()}
        >
          <div style={{ position: "relative", display: "inline-block" }}>
            <FaGlobe size={30} color="#ff4d4d" />
            <FaLock
              size={15}
              color="#000"
              style={{ position: "absolute", top: 0, right: 0 }}
            />
          </div>

          <h2>Access Restricted</h2>
          <p className="text-success fw-bold">
            {ipCheckData?.data?.message}{" "}
            <span className="text-danger">
              {ipCheckData?.data?.country}, {ipCheckData?.data?.country_code}
            </span>{" "}
          </p>
          <p>
            Your current IP address is not allowed to access this website.
            <br />
            Please{" "}
            <a
              href={`mailto:${process?.env?.REACT_APP_EMAIL_TO}`}
              className="text-decoration-none fw-bold"
            >
              contact support{" "}
            </a>
            if you believe this is a mistake.
          </p>
        </div>
      </div>
    );
  }

  return null;
}

export default IpRestrictionsCheck;
